import React from 'react'
import { Dialog } from "@progress/kendo-react-dialogs";
import UpgardeContent from './UpgradeContent';

const Upgarde = ({ toggleDialog, Type, Headline, organization }) => {

    return (
        <Dialog
            width={'40%'}
            title={' '}
            autoFocus={true}
            onClose={toggleDialog}
        >
            <UpgardeContent
                organization={organization}
                Headline={Headline}
                toggleDialog={toggleDialog}
                Type={Type}
            />
        </Dialog>
    )
}

export default Upgarde
